import classNames from 'classnames';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Size } from '../types/size.type';
import { LoadingProps } from './loading.types';

const sizeClasses: Record<Size, string> = {
  tiny: 'loading-xs',
  small: 'loading-sm',
  medium: 'loading-md',
  large: 'loading-lg',
};

export const Loading: React.FC<LoadingProps> = ({
  textKey,
  className,
  size = 'medium',
  type = 'spinner',
}) => {
  const { t } = useTranslation();

  const classes = classNames('loading', className, {
    [sizeClasses[size]]: size,
  });

  const loaderClasses = classNames('loading-loader', {
    [`loading-loader-${type}`]: type,
  });

  return (
    <span className={classes}>
      <span className={loaderClasses}></span>
      {textKey && (
        <span className="loading-text">
          <Trans t={t}>{textKey}</Trans>
        </span>
      )}
    </span>
  );
};
